import React, { useState, useEffect } from 'react';
import { useTranslation } from 'utils/i18n';
// BotWidget is now global in App.js - no import needed
import { ProofContainer } from 'coreIndex';
import CustomerHeroSection from './components/CustomerHeroSection/CustomerHeroSection';
import TrustBadges from './components/TrustBadges/TrustBadges';
import DemoSection from './components/DemoSection/DemoSection';
import homepageTranslations from './translations';
import './CustomerHomepage.css';

const CustomerHomepage = () => {
  const { language } = useTranslation();
  // eslint-disable-next-line no-unused-vars
  const [, setIsMobile] = useState(false);

  // Check if mobile device
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  // Get page-specific translations
  // eslint-disable-next-line no-unused-vars
  const t = (key, defaultValue = '') => {
    const pageTranslations = homepageTranslations[language] || homepageTranslations.en;
    const value = key.split('.').reduce((obj, k) => obj?.[k], pageTranslations.customerHomepage || pageTranslations);
    // Handle arrays correctly - check if value is an array or if it exists
    if (Array.isArray(value)) {
      return value;
    }
    if (value !== undefined && value !== null && value !== '') {
      return value;
    }
    return defaultValue !== '' ? defaultValue : key;
  };

  return (
    <div className="customer-homepage">
      {/* Customer Hero Section - Marketplace-focused */}
      <CustomerHeroSection />

      {/* Trust Badges - Compact trust signals */}
      <TrustBadges />

      {/* Demo Section - Interactive bot demo */}
      <DemoSection />

      {/* Proof Container - Impact Metrics and Case Studies */}
      <ProofContainer hideTechStack={true} hideIntegrationsTab={true} />
      
      {/* Bot Widget is now global - no need for individual instances */}
    </div>
  );
};

export default CustomerHomepage;
